import type { IconSvgObject } from './types';

const TramIcon: IconSvgObject = [
  ["path", { d: "M5 2H14M19 2H14M14 2L12 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 20L7 22M16 20L17 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 17V8C19 6.34315 17.6569 5 16 5H8C6.34315 5 5 6.34315 5 8V17C5 18.6569 6.34315 20 8 20H16C17.6569 20 19 18.6569 19 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.5 17H19M5 17H7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M5 13C7.11108 13.655 9.375 14 11.5625 14C13.75 14 16.8722 13.5802 19 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default TramIcon;
